export default {
	headers: {
		financialFiles: 'الملف المالي',
		user: 'المستخدم',
		change: 'التغيير',
		changeType: 'نوع التغيير',
		date: 'التاريخ',
		description: 'التوصيف'
	},
	label: {
		logType: 'نوع السجل',
		user: 'المستخدم',
		fromDate: 'من تاريخ',
		toDate: 'إلى تاريخ'
	},

	accounts: 'الحسابات',
	accounting: 'محاسبة',
	currencies: 'العملات',
	'financial-file': 'الملف المالي',
	'fund-flow': 'حركة مالية',
	manufacturing: 'تصنيع',
	'material-flow': 'حركات المواد',
	'material-warehouse': 'مواد مستودع',
	users: 'مستخدمين',


	fetch: 'قراءة',
	create: 'إنشاء',
	update: 'تحديث',
	edit: 'تعديل',
	delete: 'حذف',
	post: 'ترحيل',
	unPost: 'إلغاء ترحيل',

	search: 'بحث',

	'full-log-types': {
		'financial-files': 'الملفات المالية',
		accounts: 'الحسابات',
		'contact-infos': 'معلومات التواصل',
		'financial-file-config': 'إعدادات الملف المالي',
		currencies: 'العملات',
		'custom-statements': 'كشف حساب مخصص',
		'receipt-bonds': 'سندات قبض',
		'payment-bonds': 'سندات الدفع',
		'cash-entries': 'قيود يومية نقدية',
		'accounting-entries': 'قيود يومية محاسبية',
		'cash-bonds': 'السندات النقدية',
		'accounting-bonds': 'السندات المحاسبية',
		'receipt-entries': 'قيود مقبوضات',
		'payment-entries': 'قيود مدفوعات',
		'sub-invoices': 'الفواتير الفرعية',
		'buy-invoices': 'فواتير الشراء',
		'sale-invoices': 'فواتير البيع',
		'buy-refund-invoices': 'فواتير مرتجع الشراء',
		'sale-refund-invoices': 'فواتير مرتجع البيع',
		'buy-material-entries': 'قيود فاتورة شراء',
		'sale-material-entries': 'قيود فاتورة بيع',
		'buy-refund-material-entries': 'قيود مرتجع شراء',
		'sale-refund-material-entries': 'قيود مرتجع بيع',
		roles: 'أدوار',
		users: 'المستخدمين',
		'transaction-bonds': 'سندات المناقلة',
		'transaction-entries': 'قيود سند المناقلة',
		'manufacturing-files': 'ملفات التصنيع',
		'manufacturing-file-entries': 'قيود سند التصنيع',
		'manufacturing-file-entry-raw-materials': 'مكونات لقيد سند التصنيع',
		'material-journals': 'يوميات المواد',
		'material-entries': 'قيود يومية مواد',
		'receipt-invoice-transactions': 'قيود سند قبض',
		'payment-invoice-transaction': 'قيود سند دفع',
		'expenses-buy-invoice-transaction': 'مصاريف فاتورة شراء',
		'expenses-sale-invoice-transaction': 'مصاريف فاتورة بيع',
		materials: 'المواد',
		'linked-materials': 'المواد المرتبطة',
		'unit-sizes': 'وحدات القياس',
		warehouses: 'المستودعات',
		'delivery-statuses': 'حالات التسليم',
		'invoice-transactions': 'حركات داخل الفاتورة'
	}
}